import { forwardRef, ReactNode } from 'react'

const Overlay = forwardRef<HTMLDivElement, { children: ReactNode; id: string }>(
  function Overlay(props, ref) {
    return <div ref={ref} {...props} />
  }
)

export default Overlay
